export const PracticeAnalyticsURLs = {
  BASE: '/analytics/practice',
  MAIN: '/analytics/practice/main',
};
